<template>
  <v-container fill-height>
    <v-layout
      wrap
      pb-5
    >
      <v-flex
        md4
        hidden-sm-and-down
      >
        <v-card
          img="/static/NB.svg"
          height="200px"
        />
      </v-flex>
      <v-flex
        xs12
        md8
        :pl-5="$vuetify.breakpoint.mdAndUp"
      >
        <h2
          class="title mb-3"
        >
          Business Solutions
        </h2>
        <p>
          It all comes down to an understanding of <span class="important">the customer and the business</span>
          in relation to <span class="important">technological and organizational threats and opportunities</span>.
        </p>
        <div>
          NBinfo is passionate about development and finding:
          <ul>
            <li>Solutions to the real problems</li>
            <li>Simple solutions to complex problems</li>
          </ul>
        </div>
      <!--
        <h2
          class="title mb-3"
          v-text="$t('Services.heading1')"
        />
        <p v-text="$t('Services.headingText1')" />
        :pl-5="$vuetify.breakpoint.mdAndUp"
        class="py-5"
        sm8
      -->
      </v-flex>
      <v-flex
        xs12
        md8
        pt-4
        pr-4
      >
        <h2 class="title mb-3">
          System Development
        </h2>
        <p>
          System Development has many aspects and details that has to be considered. The danger is to get lost in complicated details
          or to choose a standard solution that may solve an irrelevant problem.
        </p>
        <p>That is why a <span class="important">shared understanding of problem &amp; solution</span> is alpha and omega</p>
        <p>But perhaps the most important principle is: <span class="important">Keep it simple (stupid)!</span></p>
      </v-flex>
      <v-flex
        xs12
        md4
        pt4
      >
        <div class="pt-4">
          <p>&nbsp;</p>
          <img src="/static/nbsystem.svg">
        </div>
      </v-flex>
      <v-flex
        xs12
        md6
        pt4
      >
        <div class="pt-4">
          <img src="/static/nbuml.png">
        </div>
      </v-flex>
      <v-flex
        xs12
        md6
        pt4
      >
        <div class="pt-4">
          <p>&nbsp;</p>
          <p>To day there is all kind of <span class="important">system tools and services on the internet</span> or "in the cloud".</p>
          <p>They are generally well developed, quit cheap and very easy to use. The only reasons to hesitate is:</p>
          <ul>
            <li>how do we integrate these services in the organization?</li>
            <li>uncertainty around many aspects of security!</li>
          </ul>
          <p />
          <p><span class="important">NBinfo has many years of experience with many of the best tools and technologies used today in system development and integration</span>.</p>
          <p>
            <img src="/static/nbsystemAndTools.svg">
          </p>
        </div>
      </v-flex>

      <!--
        hidden-sm-and-down
        <v-card
        img="/static/nbsystem.svg"
        height="255px"
      />
        <h2
          class="title mb-3"
          v-text="$t('Services.heading2')"
        />
        <p v-text="$t('Services.headingText2a')" />
        <p v-text="$t('Services.headingText2b')" />
        <p v-text="$t('Services.headingText2c')" />

    </v-flex>
      <v-flex xs12>
        <v-layout justify-center>
          <v-flex
            xs12
            md4
          >
            asdfasdfasdfa
            <alpha-testimonial
              :author="testimonial.author"
              :title="testimonial.title"
              :quote="testimonial.quote"
            />
          </v-flex>
        </v-layout>
        -->
      <v-flex xs12>
        <v-layout justify-center>
          <div class="v-card__actions">
            <button
              type="button"
              class="px-5 v-btn theme--light primary"
              @click="learnMore"
            >
              <div class="v-btn__content">
                Learn More?
              </div>
            </button>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style scoped>
  span.important {font-weight:bold; color:#ec8000;}
  v-btn.mt-4 {background-color:#ec8000 !important;}
</style>

<script>
  // div.mt-4 { margin-top: 48px !important;}
  import router from '../router'
  export default {
    metaInfo: {
      title: 'Services',
      meta: [
        { name: 'description', content: 'Customized vue-cli templates for Vue and Vuetify' }
      ]
    },
    computed: {
      testimonial () {
        return {
          quote: this.$t('Services.testimonial.quote'),
          author: this.$t('Services.testimonial.author'),
          title: this.$t('Services.testimonial.title')
        }
      }
    },
    methods: {
      learnMore: function () {
        router.push({ path: '/tools' })
      }
    }
  }
</script>
